module.exports = __webpack_public_path__ + "img/01.5c07c3f8.jpg";